import React, { createContext, useContext, useState } from 'react';
import { translations } from '../translations';
import { translationPatches } from '../i18n/translationPatches';
import { regionDistrictLabels } from '../data/regionDistrictLabels';

const mergedTranslations = {
  uz: { ...translations.uz, ...(translationPatches.uz || {}) },
  ru: { ...translations.ru, ...translationPatches.ru },
  en: { ...translations.en, ...translationPatches.en },
};

const LanguageContext = createContext();

// Mavjud tillar ro'yxati - kelajakda yangi tillar qo'shish oson
export const availableLanguages = [
  { code: 'uz', name: 'O\'zbek', nativeName: 'O\'zbekcha' },
  { code: 'ru', name: 'Russian', nativeName: 'Русский' },
  { code: 'en', name: 'English', nativeName: 'English' }
  // Kelajakda qo'shish mumkin:
  // { code: 'kz', name: 'Kazakh', nativeName: 'Қазақша' },
];

const LANG_STORAGE_KEY = 'adde_public_lang';

function readStoredLanguage() {
  try {
    const s = window.localStorage?.getItem?.(LANG_STORAGE_KEY);
    if (s === 'ru' || s === 'en' || s === 'uz') return s;
  } catch {
    /* ignore */
  }
  return 'uz';
}

function readLangFromUrl() {
  if (typeof window === 'undefined') return null;
  try {
    const p = new URLSearchParams(window.location.search).get('lang');
    if (p === 'ru' || p === 'en' || p === 'uz') return p;
  } catch {
    /* ignore */
  }
  return null;
}

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (typeof window !== 'undefined') {
      const fromUrl = readLangFromUrl();
      if (fromUrl) return fromUrl;
      return readStoredLanguage();
    }
    return 'uz';
  });

  const t = (key, fallback) => {
    const val = mergedTranslations[language]?.[key] ?? regionDistrictLabels[language]?.[key];
    if (val != null && String(val).trim() !== '') {
      return val;
    }
    if (fallback !== undefined && fallback !== null && String(fallback).trim() !== '') {
      return fallback;
    }
    return key;
  };

  const switchLanguage = (lang) => {
    if (availableLanguages.find(l => l.code === lang)) {
      setLanguage(lang);
      try {
        window.localStorage?.setItem?.(LANG_STORAGE_KEY, lang);
      } catch {
        /* ignore */
      }
    }
  };

  const getCurrentLanguage = () => {
    return availableLanguages.find(l => l.code === language) || availableLanguages[0];
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      t, 
      switchLanguage, 
      availableLanguages,
      getCurrentLanguage 
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

